import React, { useState } from "react";
import { Form, Input, message } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import BgWrapper from "../../components/layout/BgWrapper";
import { resetReqInfo, resetSuccessInfo } from "./constants";
import { ResetRequest, ResetSuccess } from "../../components/_shared/ResetView";

function ForgotPass() {
  const [resetReq, setResestReq] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onFinish = (values: any) => {
    // console.log("Received values of form: ", values);
    setResestReq(true);
  };

  const onResendEmail = () =>
    message.success("Request has been sent successfully");

  return (
    <BgWrapper>
      <>
        {resetReq && (
          <ResetSuccess info={resetSuccessInfo} onClick={onResendEmail} />
        )}
        {resetReq || (
          <ResetRequest info={resetReqInfo} onFinish={onFinish}>
            <Form.Item
              name="email"
              rules={[{ required: true }, { type: "email" }]}
            >
              <Input
                prefix={<MailOutlined className="text-primary pr-1" />}
                placeholder="Email"
              />
            </Form.Item>
          </ResetRequest>
        )}
        <div className="flex justify-between">
          <div>Remembered your password?</div>
          <Link to="/login" className="text-primary hover:text-primary">
            Sign In
          </Link>
        </div>
      </>
    </BgWrapper>
  );
}

export default ForgotPass;
